import { combineReducers, legacy_createStore } from "redux";
import AuthReducer from "./AuthData";

const root = combineReducers({
    auth: AuthReducer
});

export default legacy_createStore(root);